import { render, staticRenderFns } from "./ThankYouForUpgrade.vue?vue&type=template&id=26ebf5c2&scoped=true&"
import script from "./ThankYouForUpgrade.vue?vue&type=script&lang=js&"
export * from "./ThankYouForUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouForUpgrade.vue?vue&type=style&index=0&id=26ebf5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ebf5c2",
  null
  
)

export default component.exports